import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NavItem } from '@contler/models/ui';
import { TranslateModule } from '@ngx-translate/core';

import { HotelColorDirective } from '../../directives/text-hotel-color.directive';

@Component({
  selector: 'ctr-menu-item',
  imports: [CommonModule, MatIconModule, HotelColorDirective, TranslateModule, RouterModule],
  templateUrl: './menu-item.component.html',
  styles: [
    `
      .color-hotel {
        color: var(--ctr-primary-color);
      }
    `,
  ],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
    ]),
  ],
})
export class MenuItemComponent implements OnChanges {
  @Input() navItem: NavItem | undefined;
  @Input() depth = 0;
  expanded = false;
  isLink = signal<boolean>(false);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['navItem']) {
      this.isLink.set(this.isSamePath());
    }
  }

  clickItem(): void {
    if (this.navItem?.link) {
      if (this.navItem?.typeNavigation === 'external') {
        window.open(this.navItem.link, '_self');
      } else {
        this.router.navigate([this.navItem.link]);
      }
    } else {
      this.toggleItem();
    }
  }

  toggleItem(): void {
    if (this.navItem?.child) {
      this.expanded = !this.expanded;
    }
  }

  private isSamePath(): boolean {
    if (this.navItem) {
      const currentPath = '/' + this.route.snapshot.url.join('/');
      return currentPath === this.navItem.link;
    }
    return false;
  }
}
